import React from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/system";
import { Button, Spinner } from "react-bootstrap";
import { colors } from "../config/colors";
import { DISPLAY_FLEX, FLEX_JUSTIFY_CENTER } from "../config/styles";

const PrimaryButtonStyled = styled(Button, {
  shouldForwardProp: (prop) => 
    prop !== "noBorder" && prop !== "centerAlign" && prop !== "bgColor",
})(({ theme, noBorder, centerAlign, bgColor }) => ({
  ...theme.typography.body1,
  display: DISPLAY_FLEX,
  flex: 1,
  height: "40px",
  justifyContent: FLEX_JUSTIFY_CENTER,
  alignItems: centerAlign ? "center" : "flex-start",
  backgroundColor: bgColor || colors.primary,
  color: colors.white,
  border: noBorder ? "none" : `1px solid ${bgColor || colors.primary}`,
  borderRadius: "4px",
  padding: "8px 16px",
  "&:disabled": {
    backgroundColor: colors.white,
    borderColor: colors.grayBackground,
    color: colors.nonActive,
    cursor: "not-allowed",
  },
  "&:hover": {
    backgroundColor: colors.primary,
    color: colors.white,
    border: noBorder ? "none" : `1px solid ${colors.primary}`,
  },
}));

export const PrimaryButton = ({
  label = "",
  disabled = false,
  isLoading = false,
  onClick = null,
  spinnerColor = "light",
  bgColor = null,
  noBorder = false,
  centerAlign = false,
}) => {
  const btnChild = isLoading ? (
    <div style={{ marginTop: -30 }}>
      <Spinner animation="border" variant={spinnerColor} size="sm" />
    </div>
  ) : (
    label
  );
  return (
    <PrimaryButtonStyled
      bsPrefix="button-primary"
      onClick={onClick}
      disabled={isLoading || disabled}
      noBorder={noBorder}
      centerAlign={centerAlign}
      bgColor={bgColor}
    >
      {btnChild}
    </PrimaryButtonStyled>
  );
};

PrimaryButton.propTypes = {
  label: PropTypes.string,
  disabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  onClick: PropTypes.func,
  spinnerColor: PropTypes.string,
  noBorder: PropTypes.bool,
  centerAlign: PropTypes.bool,
  bgColor: PropTypes.string,
};
